module.exports = __webpack_public_path__ + "img/placeholder.7c11b9d1.png";